/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { IAsset } from "@/interfaces";
import {
  getWalletClient,
  getContract,
  getNetwork,
  switchNetwork,
  getAccount,
  writeContract,
  waitForTransaction,
} from "@wagmi/core";
import { BigNumber, ethers } from "ethers";
import { makeAutoObservable, runInAction } from "mobx";
import { abi } from "./abi";
import RestAPIClient from "@/repo/restApi";

import { getEthersSigner } from "../contract";

const IS_TESTNET = process.env.REACT_APP_IS_TESTNET === "true";
const CHAIN_ID = IS_TESTNET ? 373737 : 8794598;
export interface IMyAsset {
  asset: IAsset;
  balance: BigNumber;
}
export interface MyWalletState {
  myAssets: IMyAsset[];
}
export default class MyWalletStore {
  state: MyWalletState = {
    myAssets: [],
  };
  restApi: RestAPIClient<unknown>;
  constructor() {
    this.restApi = new RestAPIClient("wallet");
    makeAutoObservable(this);
  }
  setNetwork = async () => {
    const network = await getNetwork();
    if (network.chain?.id !== (IS_TESTNET ? 373737 : 8794598)) {
      await switchNetwork({
        chainId: IS_TESTNET ? 373737 : 8794598,
      });
    }
  };
  instance = async (): Promise<any> => {
    // const walletClient = await getWalletClient();

    return getContract({
      address: (process.env.REACT_APP_WALL_CONTRACT_ADDRESS || "") as any,
      abi: abi,
    });
  };
  public setAssets = (assets: IAsset[]) => {
    runInAction(() => {
      this.state.myAssets = assets.map((asset) => {
        return {
          asset,
          balance: BigNumber.from(0),
        };
      });
    });
  };
  public fetchBalancesOfTokens = async (tokenAddress: string) => {
    await this.setNetwork();
    const contract = await this.instance();
    const account = await getAccount();

    const balance = await contract.read.tokenBalances([
      account.address,
      tokenAddress,
    ]);
    runInAction(() => {
      this.state.myAssets = this.state.myAssets.map((asset) => {
        if (asset.asset.address === tokenAddress) {
          asset.balance = BigNumber.from(balance);
        }
        return asset;
      });
      // console.log(this.state.myAssets);
    });
  };
  public deposit = async (tokenAddress: string, amount: BigNumber) => {
    await this.setNetwork();
    await this.instance();
    if (tokenAddress.indexOf("0x00000") == 0) {
      // const walletClient = await getWalletClient();
      const { hash } = await writeContract({
        address: (process.env.REACT_APP_WALL_CONTRACT_ADDRESS || "") as any,
        abi: abi,
        functionName: "deposit",
        args: [tokenAddress, amount],
        value: BigInt(amount.toString()),
      });
      await waitForTransaction({ hash });
      // const tx = await contract.write.deposit([tokenAddress, amount], {
      //   value: amount,
      // });

      // await tx.wait();
    } else {
      // approve first

      const walletClient = await getWalletClient();
      if (walletClient) {
        const signer = await getEthersSigner({ chainId: CHAIN_ID });
        const erc20 = new ethers.Contract(
          tokenAddress,
          ["function approve(address spender, uint256 amount)"],
          signer,
        );
        const tx = await erc20.approve(
          process.env.REACT_APP_WALL_CONTRACT_ADDRESS || "",
          amount,
        );
        await tx.wait();
        const { hash } = await writeContract({
          address: (process.env.REACT_APP_WALL_CONTRACT_ADDRESS || "") as any,
          abi: abi,
          functionName: "deposit",
          args: [tokenAddress, amount],
        });
        await waitForTransaction({ hash });
      }
    }
    await this.fetchBalancesOfTokens(tokenAddress);
  };
  public withdraw = async (tokenAddress: string, amount: BigNumber) => {
    await this.setNetwork();
    const contract = await this.instance();
    if (tokenAddress.indexOf("0x00000") == 0) {
      const walletClient = await getWalletClient();
      const account = await getAccount();
      const nonce = await contract.read.walletNonce([account.address]);
      const message = ethers.utils.solidityKeccak256(
        ["uint256", "address", "uint256"],
        [amount, account.address, nonce],
      );
      const signature = await walletClient?.signMessage({
        message: { raw: ethers.utils.arrayify(message) },
      });
      await this.restApi.post({
        method: "withdraw",
        request: {
          amount: amount.toString(),
          user_address: account.address,
          nonce: nonce.toString(),
          signature: signature,
        },
      });
      await sleep(7000);
      this.fetchBalancesOfTokens(tokenAddress);
    } else {
      const { hash } = await writeContract({
        address: (process.env.REACT_APP_WALL_CONTRACT_ADDRESS || "") as any,
        abi: abi,
        functionName: "withdraw",
        args: [tokenAddress, amount],
      });
      await waitForTransaction({ hash });
    }
    this.fetchBalancesOfTokens(tokenAddress);
  };
  public checkOverLimitWithdrawDeposit = async (
    tokenAddress: string,
    amount: BigNumber,
  ): Promise<boolean> => {
    await this.setNetwork();
    const contract = await this.instance();
    const account = await getAccount();
    const overLimit = await contract.read.validateUserKycDailyLimit([
      account.address,
      tokenAddress,
      amount,
    ]);
    return overLimit;
  };

  // getters
  get myAssets() {
    return this.state.myAssets;
  }
}
function sleep(arg0: number) {
  //create a promise that resolves after "ms" milliseconds
  return new Promise((resolve) => setTimeout(resolve, arg0));
}
